import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

const CircleLoader = () => (
  <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
    <CircularProgress
      style={{ color: '#4a4a4a', animationDuration: '600ms' }}
      variant="indeterminate"
      disableShrink
      size={24}
      thickness={4}
    />
  </div>
);

export { CircleLoader };


// WEBPACK FOOTER //
// ./src/components/CircleLoader.js